import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from "../../Components/Header/Header";
import ShopBanner from "../../Components/Banner/Banner";
import Footer from '../../Components/Footer/Footer';
import './ProductDetails.css';
import BottomNavigation from '../../Components/BottomMenu/BottomNavigation';
import { addToWishlist, addToCart, getWishist, getCartist, getproductdetails, getcartwishlistcount, getProducts } from "../../redux/services/productService";
import banner1 from "../../assets/images/banner1.png"
import SearchHeader from "../../Components/Header/SearchHeader";
import HeaderDummy from "../../Components/Header/HeaderDummy";
import { Maximize,Heart, ShoppingCart, } from 'lucide-react';
import { AiOutlineShopping } from 'react-icons/ai';
import Swal from "sweetalert2";

const ProductDetails = () => {
  const { state } = useLocation();
  const product = state?.product; // ✅ this is the clicked product
  const from = state?.from || 'shop'; // default to 'shop'

  const [details, setDetails] = useState({});
  const [wishlist, setWishlist] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const [userId, setUserId] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [cartTrigger, setCartTrigger] = useState(0);
    const [wishlistTrigger, setWishlistTrigger] = useState(0);
    const [isLowEndDevices, setIsLowEndDevices] = useState(window.innerWidth <= 950);
     const [cartwishlistCount, setCartwishlistCount] = useState({CartCount:0,WishlistCount:0,CartAmount:0});
     const [latestProducts, setlatestProducts] = useState([])
       const [latestCurrentIndex, setLatestCurrentIndex] = useState(0);
       const [typingTimeout, setTypingTimeout] = useState(null);
       const cardsPerSlide = 5;
  const navigate = useNavigate();

  
  
    useEffect(() => {
    const handleResize = () => setIsLowEndDevices(window.innerWidth <= 950);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

    // Recalculate total slides when products or cardsPerSlide changes
  const latestTotalSlides = Math.ceil(latestProducts.length / cardsPerSlide);
  // Reset index when total slides change
  useEffect(() => {
    if (latestCurrentIndex >= latestTotalSlides) {
      setLatestCurrentIndex(Math.max(0, latestTotalSlides - 1));
    }
  }, [latestTotalSlides, latestCurrentIndex]);

  useEffect(() => {
    const fetchDeatils = async () => {
      try {
        const res = await getproductdetails({ be: 1, product: product?.Id });
        
        if (res?.status == "Success") {
          const parsedResult = JSON.parse(res?.result);
          setDetails(parsedResult[0]);
        }
        
        
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    };
    fetchDeatils();
  }, [product?.Id]);


    useEffect(() => {
    const fetchRelatedProducts = async () => {
      try {
       const res = await getProducts({
                 category: details?.RelatedCategory,
                 pageSize: 20,
       })
        
        if (res?.status == "Success") {
          const parsedResult = JSON.parse(res.result);
          setlatestProducts((parsedResult.Data || []).filter(p => p.Id !== details?.Id));

        }
        
        
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    };
    if(details?.RelatedCategory>0)
    fetchRelatedProducts();
  }, [details]);


  useEffect(() => {
    const storedData = localStorage.getItem('userData');

    if (storedData) {
      let parsedData = JSON.parse(storedData);

      // Check if parsedData is still a string (double stringified case)
      if (typeof parsedData === 'string') {
        parsedData = JSON.parse(parsedData);
      }

      if (parsedData && parsedData[0]?.UserId) {
        setUserId(parsedData[0].UserId);
      }
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [product?.Id]);
    useEffect(() => {
 
     const fetchCart = async () => {
            try {
              const res = await getCartist();
              const parsedResult = JSON.parse(res.result);
              if (parsedResult?.Data) {
                const mappedItems = parsedResult.Data.map((item, index) => ({
                  id: item.TransId || index,
                  transId: item.TransId,
                  productId: item.Product_Id,
                  name: item.Product_Name || "Unnamed Product",
                  price: item.Rate || 0,
                  quantity: item.Quantity || 1,
                  image: "/api/placeholder/60/60",
                }));
                setCartItems(mappedItems);
                setCartCount(mappedItems.length);
              }
            } catch (error) {
              console.error("Error fetching cart:", error);
            }
          };
 
    fetchCart();
  }, []);
  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        const res = await getWishist();
        const parsedResult = JSON.parse(res.result);
        setWishlist(parsedResult.Data || []);
        
      } catch (error) {
        console.error("Error fetching wishlist:", error);
      }
    };
    fetchWishlist();
  }, []);

    useEffect(() => {
        const fetchCartWishlistCount = async () => {
          try {
            const res = await getcartwishlistcount({BE:1});
            if(res?.status =="Success"){
              const parsedResult = JSON.parse(res.result);
              
              setCartwishlistCount(parsedResult[0]);
            }
            else{
              setCartwishlistCount({});
            }
            
          } catch (error) {
            console.error("Error fetching wishlist:", error);
            setCartwishlistCount({});
          }
        };
    
        fetchCartWishlistCount();
      }, [wishlistTrigger,cartTrigger]);
  const handleAddToWishlist = async (product) => {
    try {
      const payload = {
        transId: 0,
        product: product.Id,
        quantity: 1,
        customer: userId,
        remarks: "",
        be: 0,
        rate: product.Rate
      };
      await addToWishlist(payload);
      setWishlist([...wishlist, { Product: product.Id }]);
      setWishlistTrigger(prev => prev + 1);
    } catch (err) {
      console.error("Error adding to wishlist:", err);
    }
  };

  const handleAddToCart = async (product) => {
    if (!quantity || quantity < 1) {

    Swal.fire({
              icon: "error",
              //title: "Error",
              text: `Please enter a valid quantity`,
            });
             return; 
  }

  if (quantity > details.Stock) {
 
    Swal.fire({
              icon: "error",
              //title: "Error",
              text: `Only ${details.Stock} quantity available in stock.`,
            });
             return; 
  }
    try {
      const payload = {
        transId: 0,
        date: new Date().toISOString().split("T")[0],
        customer: userId,
        warehouse: 2,
        remarks: "",
        discountType: 1,
        discountCouponRef: "ref01",
        discountRef: "Ref809",
        sampleRequestedBy: 1,
        product: product.Id,
        qty: quantity,
        rate: product.Rate || 0,
        unit: 1,
        totalRate: (product.Rate || 0) * quantity,
        addCharges: 0,
        discount: 0,
        discountAmt: 0,
        discountRemarks: "",
        be: 0,
      };
      await addToCart(payload);
      const newCart = [...cartItems, { productId: product.Id }];
      setCartItems(newCart);
      setCartCount(newCart.length);
      setCartTrigger(prev => prev + 1);
    } catch (err) {
      console.error("Error adding to cart:", err);
    }
  };

 const updateQuantity = (newQty) => {
   newQty = Number(newQty);
  if (newQty > details.Stock) {
  
    Swal.fire({
              icon: "error",
              //title: "Error",
              text: `Only ${details.Stock} available in stock.`,
            });
             return; 
  }

  if (newQty < 1) return;

  setQuantity(newQty);
};


  if (!details) {
    return <p style={{ textAlign: "center", margin: "50px" }}>No product selected</p>;
  }

  const inWishlist = wishlist.some((w) => w.Id === details.Id);
  const inCart = cartItems.some((c) => c.productId === details.Id);



  
    const nextLatestSlide = () => {
 
  if (window.innerWidth <= 768) {
    // Mobile: scroll behavior
    const container = document.querySelector('.products-carousel-track-latest');
   if (container) {
        const cardWidth = 290; // Approximate card width + margin
        container.scrollBy({
          left: cardWidth,
          behavior: 'smooth'
        });
      }
  } else {
  
    const container = document.querySelector('.products-carousel-container-latest');
  if (container) container.scrollBy({ left: 300, behavior: 'smooth' });

  }
};

const prevLatestSlide = () => {

  if (window.innerWidth <= 768) {
    // Mobile: scroll behavior
    const container = document.querySelector('.products-carousel-track-latest');
     if (container) {
        const cardWidth = 290; // Approximate card width + margin
        container.scrollBy({
          left: -cardWidth,
          behavior: 'smooth'
        });
      }
  } else {
    const container = document.querySelector('.products-carousel-container-latest');
  if (container) container.scrollBy({ left: -300, behavior: 'smooth' });

  }
  
};

    const handleProductView = (product) => {
    
    navigate('/view', { state: { product, from: from} });
  };
const handleQuantityTyping = (value) => {
  // allow empty while typing
  if (value === "") {
    setQuantity("");
    return;
  }

  // block non–digits
  if (!/^[0-9]+$/.test(value)) return;

  // remove leading zeros
  const cleaned = value.replace(/^0+/, '') || "0";

  setQuantity(cleaned);
};


  return (
    <>
           {isLowEndDevices ? (
  <>

      <Header />
       <SearchHeader
        cartwishlistCount={cartwishlistCount}
        categories={[]}
        selectedCategory={null}
         cartTrigger={cartTrigger}
        wishlistTrigger={wishlistTrigger}
        otherScreens={true}
         />
     </>) : (
  <>
        <HeaderDummy/>
    <SearchHeader
        cartwishlistCount={cartwishlistCount}
        categories={[]}
        selectedCategory={null}
        cartTrigger={cartTrigger}
        wishlistTrigger={wishlistTrigger}
        otherScreens={true}
         />
    <Header />
  </>
)} 
      {/* <ShopBanner
        header=""
        badgeText="Product details"
        subheader=""
        backgroundImage={banner1}
        height="60px"
      /> */}

      <div className="product-details-container" style={{paddingTop:5}}>
        {/* Breadcrumb Navigation */}
        <div className="product-breadcrumb">
          <button
            className="breadcrumb-back-btn"
            onClick={() => {
              if (from == 'wishlist') navigate('/wishlist');
              else if (from == 'home') navigate('/');
              else if (from == 'cart') navigate('/cart');
              else if (from == 'shop') navigate('/shop');
              else navigate(`/${from}`);
            }}
          >
            ← Back to {from === 'wishlist' ? 'Wishlist': from === 'home'? 'Home': from === 'cart'? 'Cart':from === 'shop'? 'Shop': from}
          </button>
        </div>

        <div className="product-layout">
          {/* Left Side - Image */}
          <div className="product-image-section">
            {details?.sale && (
              <div className="discount-badge">-{details?.sale}%</div>
            )}
            {details?.Stock === 0 && (
              <div className="home-product-details-popup-sold-out-badge">SOLD<br />OUT</div>
            )}

            <div className="product-image-wrapper">
              <img
                src={details?.Image || "/api/placeholder/400/400"}
                alt={details?.Name}
                className="product-image5"
              />
            </div>
            <button
                            className="enlarge-btn"
                            style={{marginRight:"30px"}}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent opening popup when clicking enlarge
                              setSelectedProduct(details);
                              setShowPopup(true);
                            }}
                          >
                            <Maximize size={18} />Click to Enlarge
                          </button>
          </div>

          {/* Right Side - Details */}
          <div className="product-info-section">
            <h1 className="product-title">{details?.Name}</h1>
            {details ? (
              <>
                {/* <span className="original-price" style={{fontSize: '20px', margin: '5px'}}>
                      AED {(product.Rate + 20).toFixed(2)}
                    </span> */}
                <span className="current-price" style={{ fontSize: '25px' }}>
                  {(details?.Rate??0).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })} AED
                </span>
              </>
            ) : (
              <span className="current-price" style={{ fontSize: '25px' }}>
                {(details?.Rate??0).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })} AED
              </span>
            )}
            {/* Quantity Selector */}
            <div className="quantity-selector">
              <label className="quantity-label">Quantity:</label>
              <div className="quantity-controls" style={{backgroundColor:"#ffffff"}}>
                <button
                  className="quantity-btn quantity-decrement"
                  onClick={() => updateQuantity(Number(quantity - 1))}
                  disabled={quantity <= 1 || inCart}
                  style={{backgroundColor:"#f7f7f7"}}
                >
                  −
                </button>
                {inCart ? <span className="quantity-display">{quantity}</span> :
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="qty-input"
                    value={quantity}
                    onChange={(e) => handleQuantityTyping(e.target.value)}
                    disabled={inCart}
                  />

                }

                <button
                  className="quantity-btn quantity-increment"
                  onClick={() => updateQuantity(Number(quantity) + 1)}
                  disabled={quantity >= details?.Stock || inCart}
                  style={{backgroundColor:"#f7f7f7"}}
                >
                  +
                </button>
              </div>
            </div>
            <div className="quantity-selector">
              <label className="quantity-label">Available Quantity:</label>
              <div className="quantity-label">
                {new Intl.NumberFormat("en-US").format(details?.Stock)}
              </div>
            </div>

            {/* Price Section */}
            <div className="price-section">
              {inWishlist ? (
                <button className="product-details-added-btn"><Heart size={20} /> Wishlist Added</button>
              ) : (
                <button className="product-details-wishlist-btn" onClick={() => handleAddToWishlist(details)}><Heart size={20} /> Add to wishlist</button>
              )}
              {inCart ? (
                <button className="product-details-added-btn">✅ IN Cart</button>
              ) : (
                <button className="product-details-add-to-cart" onClick={() => handleAddToCart(details)}><AiOutlineShopping size={20} style={{
                                  transform: "scaleX(-1)",   // FLIP horizontally
                                  transformOrigin: "center"
                                }} /> Add to Cart</button>
              )}
              {/* <button className="product-details-compare-btn">🔄 Compare</button> */}
            </div>

            {/* Product Meta */}
            <div className="product-meta">
              <div className="meta-item">
                <span className="meta-label">SKU:</span>
                <span className="meta-value">{details?.Code}</span>
              </div>
              {/* <div className="meta-item">
                <span className="meta-label">Category:</span>
                <span className="meta-value">{details?.CategoryName || ""}</span>
              </div>*/}
              
              <div className="meta-item">
                <span className="meta-label">Category:</span>
                <span className="meta-value">{details?.SubCategoryName || ""}</span>
              </div>
              {details?.Description &&
                <div className="meta-item">
                  <span className="meta-label">Description:</span>
                  <span className="meta-value">{details?.Description || ""}</span>
                </div>
              }
              {details?.ExtraDescription &&
                <div className="meta-item">
                  <span className="meta-label">Extra Description:</span>
                  <span className="meta-value">{details?.ExtraDescription || ""}</span>
                </div>
              }
              {details?.Specification &&
                <div className="meta-item">
                  <span className="meta-label">Specification:</span>
                  <span className="meta-value">{details?.Specification || ""}</span>
                </div>
              }
             

            </div>
            
            {/* Product Details Popup */}
    {showPopup && selectedProduct && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.8)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999
    }}
    onClick={() => setShowPopup(false)}
  >
    {/* Image + Close in correct container */}
    <div
      style={{
        position: "relative",
        maxWidth: "95vw",
        maxHeight: "95vh",
        background: "transparent",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
      onClick={(e) => e.stopPropagation()} // prevent background click
    >
      {/* CLOSE BUTTON */}
      <button
        onClick={() => setShowPopup(false)}
        style={{
          position: "absolute",
          top: "-5px",
          right: "-5px",
          background: "#fff",
          color: "#e74c3c",
          border: "none",
          width: "36px",
          height: "36px",
          borderRadius: "50%",
          fontSize: "20px",
          cursor: "pointer",
          boxShadow: "0 0 10px rgba(0,0,0,0.5)",
          zIndex: 10
        }}
      >
        ✕
      </button>

      {/* IMAGE ALWAYS SHOWS */}
      <img
        src={selectedProduct?.Image || "/api/placeholder/800/800"}
        alt={selectedProduct?.Name}
        style={{
          maxWidth: "90vw",
          maxHeight: "90vh",
          objectFit: "contain",
          borderRadius: "8px",
          boxShadow: "0 0 20px rgba(0,0,0,0.5)"
        }}
      />
    </div>
  </div>
)}


          </div>
           
        </div>
        {details?.ItemSpecification &&
                <div className="productSpecification"

                >

                  <span
                    dangerouslySetInnerHTML={{ __html: details?.ItemSpecification || "" }}
                  />
                </div>
              }
              <div style={{margin:"auto",display:"flex",width:"100%",alignContent:"center",justifyContent:"center",backgroundColor:"#fff"}}>
              {latestProducts && latestProducts?.length > 0 ?
          <section className="related-products latest-products">
  <div className="section-header">
    <h2>RELATED PRODUCTS</h2>
  </div>

 <div className="carousel-wrapper">
              <div className="products-carousel-container-latest">
                <div
                  className="products-carousel-track-latest"
                  style={{
                    transform: `translateX(-${latestCurrentIndex * (100 / cardsPerSlide)}%)`
                  }}
                >
        {latestProducts.map((product) => (
        <div key={product.Id} className="product-card-detailpage" >
                      {(product.Stock === 0 || product.Stock === 0.0) && (
                        <div className="home-product-card-sold-out-badge">Sold Out</div>
                      )}
                      <div className="product-image-home" >
                        <img src={product.Image} alt={product.Name} onClick={() => handleProductView(product)} loading="lazy"/>
                        <div className="product-overlay-detailpage">
                          <button className="overlay-btn" onClick={() => handleAddToCart(product)}><ShoppingCart size={20} style={{
                  transform: "scaleX(-1)",   // FLIP horizontally
                  transformOrigin: "center"
                }}/></button>
                          {/* <button className="overlay-btn"><Search size={20} /></button> */}
                          {/* <button className="overlay-btn"><Shuffle size={20} /></button> */}
                          <button className="overlay-btn" onClick={() => handleAddToWishlist(product)}><Heart size={20} /></button>
                        </div>

                      </div>
                      <div className="product-info-home" onClick={() => handleProductView(product)}>
                        <h3>{product.Name}</h3>
                        <div className="product-pricing">
                          {/* <span className="old-price">AED {(product?.Rate + 20).toFixed(2)}</span> */}
                <span className="current-price" >{(product?.Rate ?? 0).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} AED</span>

                          {/* <button
                            className="enlarge-btn"
                            // style={{marginRight:"30px"}}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent opening popup when clicking enlarge
                              setSelectedProduct(product);
                              setShowPopup(true);
                            }}
                          >
                            <Maximize size={18} />Click to Enlarge
                          </button> */}
                        </div>
                      </div>
                    </div>
        ))}
      </div>
    </div>

    {/* Navigation Buttons - hide when no products or on mobile edge cases */}
  {/* Navigation Buttons */}
              <button className="nav-btn left" style={{ transform: "translateY(20px)" }} onClick={prevLatestSlide}>‹</button>
              <button className="nav-btn right" style={{ transform: "translateY(20px)" }} onClick={nextLatestSlide}>›</button>

    {/* Dots - only show for desktop */}
   
      <div className="dots">
        {Array.from({ length: latestTotalSlides }).map((_, index) => (
          <span
            key={index}
            className={`dot ${index === latestCurrentIndex ? "active" : ""}`}
            onClick={() => setLatestCurrentIndex(index)}
          />
        ))}
      </div>
  
  </div>
</section>
          : "No Products"}
          </div>
      </div>
    <BottomNavigation
          cartCount={cartwishlistCount?.CartCount}
          wishlistCount={cartwishlistCount?.WishlistCount}
          cartItems={cartItems}
          onCartUpdate={() => setCartTrigger(prev => prev + 1)}

        />

      <Footer />
    </>
  );
};

export default ProductDetails;
